import React from "react";
import Layout from "../Component/Layout";
import GolfImage from "../assets/Image/1.png";
import { BiMap } from "react-icons/bi";
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation } from "swiper/modules";
import "swiper/swiper-bundle.css";
import "swiper/css/navigation";
import User1 from "../assets/Image/user1.png";
import User2 from "../assets/Image/user2.png";
import { Link } from "react-router-dom";
import { useParams } from "react-router-dom";
import { usePlanContext } from "../context/plansContext";
import { useNavigate } from "react-router-dom";
import { useEffect } from "react";
import { formatDateRange, formatStayTime } from "../helper/formatDateAndTime";
import REACT_APP_API_URL from "../utils/constant";
import { useState } from "react";

const UserPlans = () => {
  const { id: userId, planId } = useParams();
  const { plans, selectedPlan, setSelectedPlan, fetchUserPlans, loading } =
    usePlanContext();
  const navigate = useNavigate();

  const [teams, setTeams] = useState([]);

  useEffect(() => {
    if (plans.length === 0) {
      fetchUserPlans(userId);
    }
  }, [userId, plans.length]);

  useEffect(() => {
    if (!selectedPlan && planId && plans.length > 0) {
      const foundPlan = plans.find((p) => String(p.id) === String(planId));
      if (foundPlan) {
        setSelectedPlan(foundPlan);
      }
    }
  }, [plans, planId, selectedPlan]);

  useEffect(() => {
    if (selectedPlan) {
      getTeamsWithPlayers();
    }
  }, [selectedPlan]);

  const getTeamsWithPlayers = async () => {
    try {
      const response = await fetch(
        `${REACT_APP_API_URL}/teams/get-teams-players`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${localStorage.getItem("user")}`,
          },
          body: JSON.stringify({
            itinerary_id: String(selectedPlan.id),
            itinerary_type: selectedPlan.type,
          }),
        }
      );

      if (!response.ok) {
        const errorText = await response.text();
        console.error("API Error Response:", errorText);
        throw new Error("Failed to fetch teams");
      }

      const result = await response.json();
      console.log("teams", result);
      setTeams(result.data);
    } catch (error) {
      console.log("Error", error);
      throw error;
    }
  };

  if (loading) return <p>Loading...</p>;
  if (!selectedPlan) return <p>No plan selected or found.</p>;

  return (
    <Layout>
      <div className="d-flex justify-content-between">
        <Link to={`/users/detail/${userId}`} className="btn btn-primary mb-4">
          Back
        </Link>
        <a
          href="#"
          className="btn btn-outline-primary mb-4"
          data-bs-toggle="modal"
          data-bs-target="#team"
        >
          Team
        </a>
      </div>

      <div className="row row-cols-1 row-cols-md-3 g-6 mb-12">
        <div className="col-lg-4 col-md-5">
          <div className="card">
            <div className="position-relative">
              <img
                className="card-img-top"
                src={selectedPlan.thumbnail}
                alt="Course"
              />
            </div>
            <div className="card-body p-5">
              <h5 className="card-title">{selectedPlan.trip_name}</h5>
              <p className="card-text mb-2">{selectedPlan.description}</p>
              <p className="card-text">
                <BiMap className="bx" />
                {selectedPlan.location}
              </p>
            </div>
          </div>
        </div>

        <div className="col-lg-8 col-md-7">
          <div className="card">
            <div className="card-body">
              <div className="stay mb-5">
                <h5 className="mb-2">Stays</h5>
                <ul className="p-0 m-0 d-flex flex-wrap gap-3 align-items-start">
                  {(selectedPlan?.stays || []).map((stay, index) => (
                    <li className="light-bg" key={index}>
                      {stay.name}
                    </li>
                  ))}
                </ul>
              </div>

              <div className="stay mb-5">
                <h5 className="mb-2">Reservation</h5>
                <ul className="p-0 m-0 d-flex flex-wrap gap-3 align-items-start">
                  <li className="light-bg">
                    {" "}
                    {formatStayTime(
                      selectedPlan.arrival_date,
                      selectedPlan.check_in,
                      selectedPlan.departure_date,
                      selectedPlan.check_out
                    )}
                  </li>
                </ul>
              </div>

              <div className="stay mb-5">
                <h5 className="mb-2">Event Duration:</h5>
                <ul className="p-0 m-0 d-flex flex-wrap gap-3 align-items-start">
                  <li className="light-bg">
                    {" "}
                    {formatDateRange(
                      selectedPlan.arrival_date,
                      selectedPlan.departure_date
                    )}
                  </li>
                </ul>
              </div>

              <div className="event ">
                <h5 className="mb-2">Rounds</h5>

                <Swiper
                  className=""
                  navigation={true} // Enable navigation
                  modules={[Navigation]}
                  spaceBetween={10}
                  breakpoints={{
                    0: { slidesPerView: 1 },
                    768: { slidesPerView: 2 },
                  }}
                >
                  {(selectedPlan.rounds || []).map((round, index) => (
                    <SwiperSlide className="border rounded-2 p-4" key={index}>
                      <h5 className="text-center mb-1 border-bottom pb-2">
                        {round.date} - {round.eventname}
                      </h5>
                      <div className="events-details text-start mt-3">
                        <h5 className="mb-1 fs-6">Event Name:</h5>
                        <p className=" mb-2" style={{ fontSize: "17px" }}>
                          {round.eventname}
                        </p>

                        <h5 className="mb-1 fs-6">Course:</h5>
                        <p className=" mb-2" style={{ fontSize: "17px" }}>
                          {round.coursename}
                        </p>
                      </div>
                    </SwiperSlide>
                  ))}
                </Swiper>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div
        className="modal fade"
        id="team"
        tabIndex="-1"
        style={{ display: "none" }}
        data-bs-backdrop="static"
      >
        <div className="modal-dialog modal-dialog-centered" role="document">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title" id="modalCenterTitle">
                Teams
              </h5>
              <button
                type="button"
                className="btn-close"
                data-bs-dismiss="modal"
              ></button>
            </div>
            <div className="modal-body">
              <Swiper
                className=""
                navigation={true} // Enable navigation
                modules={[Navigation]}
                spaceBetween={10}
                breakpoints={{
                  0: { slidesPerView: 1 },
                  768: { slidesPerView: 2 },
                }}
              >
                {teams.length > 0 ? (
                  teams.map((team, index) => (
                    <SwiperSlide
                      className="border rounded-2 p-4 h-auto"
                      key={index}
                    >
                      <h5 className="text-center mb-1 border-bottom pb-2">
                        {team.team_name}
                      </h5>
                      <div className="events-details text-start mt-3 h-100">
                        <h5 className="mb-1 fs-6">Assign Player:</h5>
                        {(team.players || []).map((player, i) => (
                          <div
                            className="d-flex align-items-center gap-2 mb-3"
                            key={i}
                          >
                            <img
                              src={player.image || User1}
                              style={{ width: 45 }}
                              height={45}
                              className="rounded-pill"
                              alt=""
                            />
                            <p className="m-0 fs-6">
                              {player.first_name} {player.last_name}
                            </p>
                          </div>
                        ))}
                      </div>
                    </SwiperSlide>
                  ))
                ) : (
                  <p className="text-muted text-center">No Teams Found</p>
                )}
              </Swiper>
            </div>
          </div>
        </div>
      </div>
    </Layout>
  );
};

export default UserPlans;
